import moment from 'moment-timezone';

class Timezone {
  constructor() {
    this.timestamp = document.querySelector('.js-timezone');
    this.userTimezone = moment.tz.guess();
    this.publishDate = document.querySelector('.js-post-timestamp').textContent;
    this.publishDateFormatted = document.querySelector('.js-post-timestamp__formatted').textContent;
    this.originalAMPM = document.querySelector('.js-post-timestamp__formatted_ampm').textContent;
    this.originalDay = document.querySelector('.js-post-timestamp__formatted_day').textContent;
    this.publishDateDiv = document.querySelector('.js-final-pub-date');
    this.publishDayDiv = document.querySelector('.js-final-pub-day');
    this.updatedPublishDate = document.querySelector('.js-post-timestamp__updated');
    this.updatedPublishDateDiv = document.querySelector('.js-final-pub-date__updated');
    this.updatedPublishDayDiv = document.querySelector('.js-final-pub-day__updated');
    this.init();
  }

  init() {
    // format the published date from the twig template
    const momentDate = moment.tz(this.publishDate, 'America/Chicago').format();
    // convert hours to user timezone
    this.convertedZone = moment.tz(momentDate, this.userTimezone).format('h:mm');
    // convert month, day and year to user timezone
    this.convertedZoneDay = moment.tz(momentDate, this.userTimezone).format('MMMM D, YYYY');
    // convert am/pm to user timezone
    this.convertedAMPM = moment.tz(momentDate, this.userTimezone).format('a');
    // grab user converted timezone only
    this.convertedZ = moment.tz(momentDate, this.userTimezone).format('z');

    // change am/pm to our style for the original timestamp
    if (this.originalAMPM === 'am') {
      this.originalAMPM = 'a.m.';
    } else if (this.originalAMPM === 'pm') {
      this.originalAMPM = 'p.m.';
    }

    // if the date isn't valid, use the original publish date displayed in central time
    if (this.convertedZone === 'Invalid date') {
      this.publishDateDiv.textContent = `${this.publishDateFormatted} ${this.originalAMPM} CT`;
      if (this.publishDayDiv.classList.contains('poll')) {
        // remove comma at the end of day if we are on a poll page
        this.publishDayDiv.textContent = `${this.originalDay}`;
      } else {
        this.publishDayDiv.textContent = `${this.originalDay},`;
      }

      // if the date is valid, change am/pm and timezone to our style for the updated timestamp
    } else {
      if (this.convertedAMPM === 'am') {
        this.convertedAMPM = 'a.m.';
      } else if (this.convertedAMPM === 'pm') {
        this.convertedAMPM = 'p.m.';
      }
      if (this.convertedZ === 'CST' || this.convertedZ === 'CDT') {
        this.convertedZ = 'CT';
      } else if (this.convertedZ === 'EST' || this.convertedZ === 'EDT') {
        this.convertedZ = 'ET';
      } else if (this.convertedZ === 'PST' || this.convertedZ === 'PDT') {
        this.convertedZ = 'PT';
      } else if (this.convertedZ === 'MST' || this.convertedZ === 'MDT') {
        this.convertedZ = 'MT';
        // if we do not support the user's timezone, use the original publish date in CT
      } else {
        this.convertedZone = this.publishDateFormatted;
        this.convertedAMPM = this.originalAMPM;
        this.convertedZ = 'CT';
        this.convertedZoneDay = this.originalDay;
      }
      this.publishDateDiv.textContent = `${this.convertedZone} ${this.convertedAMPM} ${this.convertedZ}`;
      // remove comma at the end of the day if we are on a poll page
      if (this.publishDayDiv.classList.contains('poll')) {
        this.publishDayDiv.textContent = `${this.convertedZoneDay}`;
      } else {
        this.publishDayDiv.textContent = `${this.convertedZoneDay},`;
      }
    }

    if (this.updatedPublishDate) {
      this.zone = document.querySelector('.js-post-timestamp__timezone-updated').textContent;

      if (this.zone === '') {
        this.zone = 'America/Chicago';
      }

      const updated = this.updatedPublishDate.textContent;

      const updatedZone = moment.tz(updated, this.zone).format();

      this.updatedConvertedZone = moment.tz(updatedZone, this.userTimezone).format('h:mm');

      this.updatedConvertedZoneDay = moment
        .tz(updatedZone, this.userTimezone)
        .format('MMMM D, YYYY');

      this.convertedAMPMUpdated = moment.tz(updatedZone, this.userTimezone).format('a');

      this.convertedZUpdated = moment.tz(updatedZone, this.userTimezone).format('z');

      // change am/pm to our style for the original timestamp

      if (this.updatedOriginalAMPM === 'am') {
        this.updatedOriginalAMPM = 'a.m.';
      } else if (this.updatedOriginalAMPM === 'pm') {
        this.updatedOriginalAMPM = 'p.m.';
      }

      // if the date isn't valid, use the original updated publish date displayed in central time
      if (this.updatedConvertedZone === 'Invalid date') {
        this.updatedPublishDateDiv.textContent = `${this.updatedPublishDateFormatted} ${this.updatedOriginalAMPM} CT`;
        // removing comma after day if poll page
        if (this.updatedPublishDayDiv.classList.contains('poll')) {
          this.updatedPublishDayDiv.textContent = `${this.updatedOriginalDay}`;
        } else {
          this.updatedPublishDayDiv.textContent = `${this.updatedOriginalDay},`;
        }
      } else {
        if (this.convertedZUpdated === 'CST' || this.convertedZUpdated === 'CDT') {
          this.convertedZUpdated = 'CT';
        } else if (this.convertedZUpdated === 'EST' || this.convertedZUpdated === 'EDT') {
          this.convertedZUpdated = 'ET';
        } else if (this.convertedZUpdated === 'PST' || this.convertedZUpdated === 'PDT') {
          this.convertedZUpdated = 'PT';
        } else if (this.convertedZUpdated === 'MST' || this.convertedZUpdated === 'MDT') {
          this.convertedZUpdated = 'MT';
        } else {
          this.updatedConvertedZone = moment.tz(updatedZone, 'America/Chicago').format('h:mm');

          this.updatedConvertedZoneDay = moment
            .tz(updatedZone, 'America/Chicago')
            .format('MMMM D, YYYY');

          this.convertedAMPMUpdated = moment.tz(updatedZone, 'America/Chicago').format('a');

          this.convertedZUpdated = 'CT';
        }

        if (this.convertedAMPMUpdated === 'am') {
          this.convertedAMPMUpdated = 'a.m.';
        } else if (this.convertedAMPMUpdated === 'pm') {
          this.convertedAMPMUpdated = 'p.m.';
        }

        this.updatedPublishDateDiv.textContent = `${this.updatedConvertedZone} ${this.convertedAMPMUpdated} ${this.convertedZUpdated}`;
        if (this.updatedPublishDayDiv.classList.contains('poll')) {
          this.updatedPublishDayDiv.textContent = `${this.updatedConvertedZoneDay}`;
        } else {
          this.updatedPublishDayDiv.textContent = `${this.updatedConvertedZoneDay},`;
        }
      }
    } else {
      return;
    }
  }
}

export default Timezone;
